import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'ps-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @Input() progressBarValue: number;
  @Input() progressbarStatus: any = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
